import React from "react";
import styled, { css } from "styled-components";
import theme from "styled-theming";
import PropTypes from "prop-types";
import { hexToRgb } from "./colors";

const getFontSize = (buttonSize) => {
  switch (buttonSize) {
    case "medium":
      return "13px";
    case "large":
      return "0.9375rem;";
  }
};

const getSidePadding = (buttonSize) => {
  switch (buttonSize) {
    case "medium":
      return "13px";
    case "large":
      return "55px";
  }
};

const getTopBottomPadding = (buttonSize) => {
  switch (buttonSize) {
    case "medium":
      return "5px";
    case "large":
      return "16px";
  }
};

const getButtonHeight = (buttonSize) => {
  switch (buttonSize) {
    case "medium":
      return "36px";
    case "large":
      return "60px";
  }
};

/**
 * Primary and secondary buttons for all button uses.
 * */
console.log("Button", styled.button);

const getMainColor = (variant, colors) => {
  if (variant === "neutral") {
    return "#999";
  }
  return colors[variant].main.color;
};

const getContrastColor = (variant, colors) => {
  if (variant === "neutral") {
    return "white";
  }
  return colors[variant].main.contrastColor;
};

const getHoverColor = (variant, colors) => {
  if (variant === "neutral") {
    return "#9f9f9f";
  }
  return colors[variant].main.hoverColor;
};

const getDisabledColor = (props) => {
  if (props.variant === "neutral") {
    return "blue";
  }
  const color = hexToRgb(props.theme.colors[props.variant].main.color);
  return `rgba(${color.r}, ${color.g}, ${color.b}, 0.4)`;
};

const baseStyle = css`
  background-color: ${(props) =>
    props.inverted
      ? "transparent"
      : getMainColor(props.variant, props.theme.colors)};
  color: ${(props) =>
    props.inverted
      ? getMainColor(props.variant, props.theme.colors)
      : getContrastColor(props.variant, props.theme.colors)} !important;
  border-radius: 5px; 
  line-height: 1.75;
    
  padding-top: ${(props) => getTopBottomPadding(props.size)};
  padding-bottom: ${(props) => getTopBottomPadding(props.size)}; 
  padding-left: ${(props) => getSidePadding(props.size)};
  padding-right: ${(props) => getSidePadding(props.size)};
  
  font-size: ${(props) => getFontSize(props.size)};
  text-transform: uppercase;
    text-decoration: none;
  font-weight: 500;
  display: inline-block;
  position: relative;
  text-align: center;
  border: none;
  cursor: pointer;
  width: ${(props) => (props.fullWidth ? "100%" : "auto")};
  border: ${(props) =>
    props.inverted
      ? "1px solid" + getMainColor(props.variant, props.theme.colors)
      : "transparent"};
  box-sizing: border-box;
  &:hover {
    background-color: ${(props) =>
      props.inverted
        ? "transparent"
        : getHoverColor(props.variant, props.theme.colors)},
    color: ${(props) =>
      props.inverted
        ? getHoverColor(props.variant, props.theme.colors)
        : getContrastColor(props.variant, props.theme.colors)},
    border: ${(props) =>
      props.inverted
        ? "1px solid" + getHoverColor(props.variant, props.theme.colors)
        : "transparent"};
  }
  
  &:disabled {
      background-color:  ${(props) =>
        props.inverted ? "transparent" : getDisabledColor(props)},
      opacity: ${(props) => (props.inverted ? 0.6 : 1)};
      cursor: default;      
    }
`;

const StyledButton = styled.button`
  ${baseStyle}
`;

const StyledLink = styled.a`
  ${baseStyle}
`;

const Button = ({ ...props }) => {
  if (props.href) {
    return <StyledLink {...props} />;
  }
  return <StyledButton {...props} />;
};

Button.propTypes = {
  variant: PropTypes.oneOf(["primary", "secondary", "neutral"]),
  children: PropTypes.node.isRequired,
  inverted: PropTypes.bool,
};

Button.defaultProps = {
  variant: "primary",
  size: "medium",
  inverted: false,
};

/** @component */
export default Button;
